import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=69ed4f52&scoped=true&lang=pug&"
import script from "./Teacher.vue?vue&type=script&lang=ts&"
export * from "./Teacher.vue?vue&type=script&lang=ts&"
import style0 from "./Teacher.vue?vue&type=style&index=0&id=69ed4f52&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ed4f52",
  null
  
)

export default component.exports